import deburr from 'lodash/deburr';

/**
 * Normalizes a location reference string in a variety of ways. The goal is to
 * make the string more directly comparable with strings we expect to find in
 * data. Transforms are described below.
 */
export function normalizeLocationRef(input: string): string {
  // deburr converts unicode Latin-1 Supplement and Latin Extended-A letters
  // to basic Latin letters. Such characters do appear in ISO 3166 names, so
  // we want to transliterate them.
  return deburr(
    input
      // Trim leading and trailing whitespace.
      .trim()
      // Remove non-hyphen punctuation.
      .replaceAll(/[^\P{P}-]+/gu, '')
      // Replace hyphens with spaces.
      .replaceAll('-', ' ')
      // Cut all whitespace strings down to one space.
      .replaceAll(/\s+/g, ' ')
      // Remove diacritics.
      .normalize('NFKD')
      .replaceAll(/\p{Diacritic}/gu, '')
      // Shift everything to lowercase.
      .toLowerCase()
  );
}
